import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocaleService } from 'src/app/services/locale.service';
import { Util } from 'src/app/util';
import { YoutubeItem } from '../../models/youtube-response';
import moment from 'moment';

@Component({
  selector: 'app-youtube-item',
  templateUrl: './youtube-item.component.html',
  styleUrls: ['./youtube-item.component.scss'],
})
export class YoutubeItemComponent implements OnInit {
  @Input()
  youtubeItem: YoutubeItem;

  @Output()
  videodata: EventEmitter<any> = new EventEmitter();

  videoDurationLabel: string;
  publishedAtLabel: string;

  constructor(private localeService: LocaleService) {}

  ngOnInit() {
    this.youtubeItem.title = Util.truncate(this.youtubeItem.title, 80);
    this.youtubeItem.description = Util.truncate(this.youtubeItem.description, 132);

    this.publishedAtLabel = this.localeService.humanize(new Date().getTime() - this.youtubeItem.publishedAt);
    this.videoDurationLabel = this.formatYoutubeDuration(this.youtubeItem.duration);
  }

  watchVideo() {
    const videoData = {
      title: this.youtubeItem.title,
      link: this.youtubeItem.embedHtml,
      directLink: 'https://www.youtube.com/watch?v=' + this.youtubeItem.id,
      externalId: this.youtubeItem.id,
      format: 'YOUTUBE',
      isFromExternalDb: true,
    };
    this.videodata.emit(videoData);
  }

  private formatYoutubeDuration(d: string) {
    const durationMillis = moment.duration(d).asMilliseconds();
    const hours = Math.floor(durationMillis / 3600000);
    const hoursRemainder = durationMillis % 3600000;
    const minutes = Math.floor(hoursRemainder / 60000);
    const minutesRemainder = hoursRemainder % 60000;
    const seconds = Math.floor(minutesRemainder / 1000);

    const hoursStr = hours > 0 ? hours : '';
    const minutesStr = minutes < 10 && hours > 0 ? '0' + minutes : minutes;
    const secondsStr = seconds < 10 ? '0' + seconds : seconds;
    return hoursStr + (hours > 0 ? ':' : '') + minutesStr + ':' + secondsStr;
  }
}
